///<reference path="../../../typings/tsd.d.ts" />

module agencyRegistration.factory {
    
    class AgentModel {
        data: API.Client.AgencyModel = {
            cnpj: undefined,
            partners: [{personType:'F'}],
            address: { countryCode: 'BR', stateCode: "SP" },
            companyData: { phones: [{ type: 'T' }] },
            bankData: {}
        };
        
        constructor() {};
    }
    
    export class agentFactory {
        agency: API.Client.AgencyModel;
        
        getAgency(): API.Client.AgencyModel {
            return this.agency;
        };
        
        setNewAgency():void {
            this.agency = $.extend(this.agency, new AgentModel().data);
        };
        
        /*@ngInject*/
        constructor(){ 
            this.agency = new AgentModel().data;
        };
    }
}
angular.module('agencyRegistrationApp').factory('agentFactory', () => new agencyRegistration.factory.agentFactory());